export const GET_EVENT_SETTINGS = "GET_EVENT_SETTINGS";
export const GET_EVENT_SETTINGS_ERROR = "GET_EVENT_SETTINGS_ERROR";
export const GET_EVENT_SETTINGS_SUCCESS = "GET_EVENT_SETTINGS_SUCCESS";
